import { Box, Typography } from "@mui/material";
import React from "react";

function LeaveResultBox({ children }) {
  return (
    <Box
      sx={{
        bgcolor: "#FF980033",
        border: "1px solid #FF9800",
        borderRadius: "4px",
        padding: "4px 8px",
        margin:"0 8px",
      }}
    >
      <Typography component={"span"} fontSize={"13px"}>
        {" "}
        {children}
      </Typography>
    </Box>
  );
}

export default LeaveResultBox;
